<template lang="pug">
  footer#footer
    .container
      .row
        .col-xs-12.col-sm-8
          span.copyright {{config.SITE_TITLE}} &nbsp; &copy; 2017{{ anoAtual() }} - Todos os direitos reservados
        .col-xs-12.col-sm-4.brand
          | Desenvolvido pela
          a.sinfo(href='http://info.ufrn.br/' title="Ir para o site da SINFO" target='_blank' noopener) SINFO
</template>

<script>
  export default {
    name: 'site-footer',
    data: () => ({ config: require('../../js/config') }),
    methods: {
      anoAtual () {
        let hoje = new Date()
        return (hoje.getFullYear() > 2017) ? '/' + hoje.getFullYear() : ''
      }
    }
  }
</script>

<style lang="scss">
  // Vars
  $rodape_background: #444242;
  $rodape_text_color: $color-neutral;
  $rodape_fonte_size: $font_size_small;

  // Style
  #footer {
    color: $rodape_text_color;
    background-color: $rodape_background;
    padding: 30px 0;
    line-height: 24px;
    font-size: $rodape_fonte_size;
    text-align: center;

    .copyright {
      vertical-align: middle;
    }

    .sinfo {
      display: inline;
      color: $rodape_text_color; 
      margin-left: 5px;
    }

    @include media(">=tablet") {
      text-align: left;

      .brand {
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PageFooter.vue?07628784